import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9f168e34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "monitor-container"
};
const _hoisted_2 = {
  key: 0,
  class: "client-charts"
};
const _hoisted_3 = {
  class: "chart-item"
};
const _hoisted_4 = {
  class: "chart-item"
};
const _hoisted_5 = {
  key: 1,
  class: "server-charts"
};
const _hoisted_6 = {
  class: "chart-item"
};
const _hoisted_7 = {
  class: "chart-item"
};
const _hoisted_8 = {
  class: "chart-item"
};
const _hoisted_9 = {
  class: "chart-item"
};
import FilterPanel from './components/FilterPanel.vue';
import PayPathChart from './components/PayPathChart.vue';
import PayErrorChart from './components/PayErrorChart.vue';
import PayPathServerChart from './components/PayPathServerChart.vue';
import PayErrorServerChart from './components/PayErrorServerChart.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const clientPayPathChartRef = ref(null);
    const clientPayErrorChartRef = ref(null);
    const serverPayPathChartRef = ref(null);
    const serverPayPathChartRef1 = ref(null);
    const serverPayErrorChartRef = ref(null);
    const serverPayErrorChartRef1 = ref(null);
    const activeKey = ref('client');
    const search = filter => {
      if (activeKey.value === 'client') {
        var _clientPayPathChartRe, _clientPayErrorChartR;
        (_clientPayPathChartRe = clientPayPathChartRef.value) === null || _clientPayPathChartRe === void 0 || _clientPayPathChartRe.getData({
          filter,
          metricType: 'PaidPathConvert4ClientMetric'
        });
        (_clientPayErrorChartR = clientPayErrorChartRef.value) === null || _clientPayErrorChartR === void 0 || _clientPayErrorChartR.getData({
          filter,
          metricType: 'PaidFailedMetric',
          version: 'v2'
        });
      } else if (activeKey.value === 'server') {
        var _serverPayPathChartRe, _serverPayPathChartRe2, _serverPayErrorChartR, _serverPayErrorChartR2;
        const serverPayPathParams = {
          filter,
          metricType: 'PaidPathConvert4ServerMetric'
        };
        (_serverPayPathChartRe = serverPayPathChartRef.value) === null || _serverPayPathChartRe === void 0 || _serverPayPathChartRe.getData({
          ...serverPayPathParams,
          version: 'v1'
        });
        (_serverPayPathChartRe2 = serverPayPathChartRef1.value) === null || _serverPayPathChartRe2 === void 0 || _serverPayPathChartRe2.getData({
          ...serverPayPathParams,
          version: 'v2'
        });
        const serverPayErrorParams = {
          filter,
          metricType: 'PaidSucceedAndSendPropertyFailedMetric'
        };
        (_serverPayErrorChartR = serverPayErrorChartRef.value) === null || _serverPayErrorChartR === void 0 || _serverPayErrorChartR.getData({
          ...serverPayErrorParams,
          version: 'v1'
        });
        (_serverPayErrorChartR2 = serverPayErrorChartRef1.value) === null || _serverPayErrorChartR2 === void 0 || _serverPayErrorChartR2.getData({
          ...serverPayErrorParams,
          version: 'v2'
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FilterPanel, {
        activeKey: activeKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event),
        onSearch: search
      }, null, 8, ["activeKey"]), activeKey.value === 'client' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(PayPathChart, {
        ref_key: "clientPayPathChartRef",
        ref: clientPayPathChartRef
      }, null, 512)]), _createElementVNode("div", _hoisted_4, [_createVNode(PayErrorChart, {
        ref_key: "clientPayErrorChartRef",
        ref: clientPayErrorChartRef
      }, null, 512)])])) : activeKey.value === 'server' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(PayPathServerChart, {
        ref_key: "serverPayPathChartRef",
        ref: serverPayPathChartRef,
        title: "付费路径转化情况(服务端)"
      }, null, 512)]), _createElementVNode("div", _hoisted_7, [_createVNode(PayPathServerChart, {
        ref_key: "serverPayPathChartRef1",
        ref: serverPayPathChartRef1,
        title: "付费路径转化情况(服务端-重构)"
      }, null, 512)]), _createVNode(_component_a_row, {
        gutter: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_a_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(PayErrorServerChart, {
            ref_key: "serverPayErrorChartRef",
            ref: serverPayErrorChartRef,
            title: "道具下发失败情况"
          }, null, 512)])]),
          _: 1
        }), _createVNode(_component_a_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(PayErrorServerChart, {
            ref_key: "serverPayErrorChartRef1",
            ref: serverPayErrorChartRef1,
            title: "道具下发失败情况(重构)"
          }, null, 512)])]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
});